import * as React from 'react';
import * as types from '../../../types';
import * as services from '../../../services';
import { IApp03EpicEvidence, App03EpicEvidence } from '../../../types';
import { CrTextField } from '../../cr/CrTextField';
import { FieldErrorMessage } from '../../cr/FieldDecorators';
import { CrChoiceGroup } from '../../cr/CrChoiceGroup';
import { FormButtons } from '../../cr/FormButtons';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { FormCommandBar } from '../../cr/FormCommandBar';
import styles from '../../../styles/cr.module.scss';
import '../../../styles/CustomFabric.scss';
import { IChoiceGroupOption } from '@fluentui/react/lib/ChoiceGroup';
import { ALL_ALLOWED_EXTENSIONS } from './EvidenceSaveForm';
import { App03Frameworks } from '../../../types/App03Workflow';
import { AppIDs, getAppKeyByValue } from '../../../AppGlobals';

export interface IEpicEvidenceSaveFormProps extends types.IBaseComponentProps {
    frameworkID: App03Frameworks;
    epicID: number;
    evidenceId: number;
    showForm: boolean;
    onFormSaved?: () => void;
    onFormCancelled?: () => void;
}

export interface IErrorMessage {
    Details: string;
    Title: string;
    FileUpload: string;
}
export class ErrorMessage implements IErrorMessage {
    public Details = null;
    public Title = null;
    public FileUpload = null;
}

export interface IEpicEvidenceSaveFormState {
    Loading: boolean;
    FormData: IApp03EpicEvidence;
    FormDataBeforeChanges: IApp03EpicEvidence;
    FormIsDirty: boolean;
    UploadStatus: string;
    UploadProgress: number;
    ShowUploadProgress: boolean;
    EditRequest: boolean;
    ErrMessages: IErrorMessage;
}

export class EpicEvidenceSaveFormState implements IEpicEvidenceSaveFormState {
    public Loading = false;
    public FormData;
    public FormDataBeforeChanges;
    public FormIsDirty = false;
    public UploadStatus = "";
    public UploadProgress: number = 0;
    public ShowUploadProgress = false;
    public EditRequest = false;
    public ErrMessages = new ErrorMessage();

    constructor(epicID: number) {
        const defaultAttachmentType: string = "None";
        this.FormData = new App03EpicEvidence(epicID, defaultAttachmentType);
        this.FormDataBeforeChanges = new App03EpicEvidence(epicID, defaultAttachmentType);
    }
}

export default class EpicEvidenceSaveForm extends React.Component<IEpicEvidenceSaveFormProps, IEpicEvidenceSaveFormState> {

    private app03EpicEvidencesService: services.App03EpicEvidencesService = new services.App03EpicEvidencesService();
    private zFileService: services.ZFileService = new services.ZFileService();

    private appID = this.props.frameworkID === App03Frameworks.Scrum ? AppIDs.AGSPR : AppIDs.CORWF;

    constructor(props: IEpicEvidenceSaveFormProps, state: IEpicEvidenceSaveFormState) {
        super(props);

        this.state = new EpicEvidenceSaveFormState(props.epicID);
    }

    public render(): React.ReactElement<IEpicEvidenceSaveFormProps> {
        const headerText: string = "Epic Discussion, General Comments and Attachments";
        return (
            <Panel isOpen={this.props.showForm} headerText={headerText} type={PanelType.medium} onRenderNavigation={() => <FormCommandBar onSave={this.saveEvidence} onCancel={this.props.onFormCancelled} /*saveDisabled={this.state.ShowUploadProgress}*/ />}>
                <div className={styles.cr}>
                    {this.renderFormFields()}
                    <FormButtons
                        primaryText={"Save"}
                        primaryDisabled={this.state.ShowUploadProgress}
                        onPrimaryClick={() => this.saveEvidence()}
                        onSecondaryClick={this.props.onFormCancelled}
                    />
                    {this.renderInfoText()}
                </div>
            </Panel>
        );
    }

    public renderInfoText() {
        if (this.state.FormData.ID > 0 && this.state.EditRequest === true && this.state.FormData.AttachmentType === "File") {
            const fileName = this.state.FormData.Title;
            return (
                <div style={{ marginTop: '20px' }}>
                    This evidence is linked to file "{fileName}". <br />
                    To change the file, please delete this evidence record and add again.
                </div>
            );
        }
        return null;
    }

    public renderFormFields() {
        return (
            <React.Fragment>
                {this.renderDetails()}
                {this.renderAttachmentTypeChoiceOptions()}
                {this.renderLinkBox()}
                {this.renderFileUpload()}

            </React.Fragment>
        );
    }

    private renderDetails() {
        return (
            <CrTextField
                label="Details"
                required={true}
                className={styles.formField}
                value={this.state.FormData.Details}
                onChange={(_, v) => this.changeTextField(v, "Details")}
                multiline={true}
                rows={3}
                errorMessage={this.state.ErrMessages.Details}
            />
        );
    }

    private renderAttachmentTypeChoiceOptions() {
        let options: IChoiceGroupOption[] = [
            { key: "None", text: 'None' },
            { key: "File", text: 'File (PDF, ZIP, Image, Word document)' },
            { key: "Link", text: 'Link' },
        ];


        const fd = this.state.FormData;

        return (
            <div>
                <CrChoiceGroup
                    label="Attachment"
                    className="inlineflex"
                    options={options}
                    disabled={this.state.EditRequest}
                    selectedKey={fd.AttachmentType}
                    onChange={(ev, option) => this.changeChoiceGroup(ev, option, "AttachmentType")}
                />
            </div>
        );
    }

    private renderLinkBox() {
        if (this.state.FormData.AttachmentType === "Link") {
            return (
                <CrTextField
                    label="Link"
                    required={true}
                    className={styles.formField}
                    value={this.state.FormData.Title}
                    onChange={(_, v) => this.changeTextField(v, "Title")}
                    errorMessage={this.state.ErrMessages.Title}
                />
            );
        }
        else
            return false;
    }

    private renderFileUpload() {
        if (this.state.EditRequest === true) return null;
        if (this.state.FormData.AttachmentType !== "File")
            return null;

        return (
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <div>
                    {/* <input
                        type="file"
                        name="fileUpload"
                        id="fileUpload"
                        accept="
                                application/pdf,
                                application/zip,
                                image/*,
                                application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                application/msword,
                                application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                application/vnd.ms-excel,
                                application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                application/vnd.ms-powerpoint
                        ">
                    </input> */}

                    <input
                        type="file"
                        name="fileUpload"
                        id="fileUpload"
                        accept="
                            application/pdf,
                            application/zip,
                            application/x-tar,
                            image/png,
                            image/jpeg,
                            image/gif,
                            image/webp,
                            image/bmp,
                            image/tiff,
                            image/svg+xml,
                            application/msword,
                            application/vnd.openxmlformats-officedocument.wordprocessingml.document
                        "
                    />

                    {this.state.ErrMessages.FileUpload && <FieldErrorMessage value={this.state.ErrMessages.FileUpload} />}
                    {/* <div style={{ paddingTop: '10px' }}>
                        Please upload all evidence as PDFs. For guidance on saving documents and emails please click <span onClick={this.viewHelpPDF} style={{ textDecoration: 'underline', cursor: 'pointer' }}>here</span>.
                    </div> */}
                </div>
                {this.state.ShowUploadProgress && <div style={{ minHeight: '80px', marginTop: '15px' }}>
                    <div>
                        {this.state.UploadStatus}
                    </div>
                    <div>
                        {this.state.UploadProgress} %
                    </div>
                </div>}
            </div>
        );
    }




    private uploadFile = async (evidenceId: number, addedByUserID: number) => {
        this.setState({
            UploadStatus: "Uploading file ...",
            ShowUploadProgress: true
        });

        let myfile = (document.querySelector("#fileUpload") as HTMLInputElement).files[0];
        let fileName: string = myfile.name;

        try {
            const appShortCode = getAppKeyByValue(this.appID);
            const response = await this.zFileService.uploadFile(appShortCode, myfile, (progressEvent) => {
                const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                this.setState({
                    UploadProgress: progress,
                    UploadStatus: progress === 100 ? "Processing file..." : "Uploading to server..."
                });
            });

            if (response.status === true) {
                this.afterFileUpload(String(response.fileID), evidenceId, fileName, addedByUserID);
            }
            else {
                console.log('error in uploading file');
            }
        } catch (error) {
            console.error('Error uploading file', error);
        }
    }


    private afterFileUpload = (fileUniqueID: string, evidenceId: number, fileName: string, addedByUserID: number): void => {
        const fdata = { ...this.state.FormData, "FileUniqueID": fileUniqueID, "Title": fileName, "ID": evidenceId, "AddedByUserID": addedByUserID };
        this.setState({
            FormData: fdata
        }, this.saveEvidence);
    }

    private viewHelpPDF = () => {
        console.log('help pdf');
    }

    private saveEvidence = (): void => {

        if (this.validateEntity()) {
            if (this.props.errorHandling?.onError) this.props.errorHandling?.onError(null);

            let f: IApp03EpicEvidence = { ...this.state.FormData };
            if (f.ID === 0) {

                //firts create record in the db, so we can get the ID, then use the ID to append in the file name to make file name unique
                this.app03EpicEvidencesService.create(f).then(x => {
                    if (this.state.FormData.AttachmentType === "File") {
                        this.uploadFile(x.ID, x.AddedByUserID);
                    }
                    else {
                        //its a link instead of the file, so close the form
                        console.log('evidence saved as link');
                        this.props.onFormSaved();
                    }
                });
            }
            else {

                this.app03EpicEvidencesService.updatePut(f.ID, f).then(this.props.onFormSaved, (err) => {
                    if (this.props.errorHandling?.onError) this.props.errorHandling?.onError(`Error updating item`, err.message);
                });
            }
        }
    }

    private validateEntity = (): boolean => {
        let returnVal: boolean = true;
        let errMsg: IErrorMessage = { ...this.state.ErrMessages };

        if ((this.state.FormData.Details === null) || (this.state.FormData.Details === '')) {
            errMsg.Details = "Details required";
            returnVal = false;
        }
        else {
            errMsg.Details = null;
        }

        if (this.state.EditRequest === false && this.state.FormData.AttachmentType === "File") {
            const file = (document.querySelector("#fileUpload") as HTMLInputElement).files[0];

            if (file == null) {
                errMsg.FileUpload = "File required";
                returnVal = false;
            }
            else {
                const fileName = file.name;
                const ext = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

                if (ALL_ALLOWED_EXTENSIONS.includes(ext)) {
                    errMsg.FileUpload = null;
                } else {
                    errMsg.FileUpload = "Only PDF, ZIP, Images, or Word documents are allowed.";
                    returnVal = false;
                }
            }

        }
        else {
            errMsg.FileUpload = null;
        }

        if (this.state.FormData.AttachmentType === "Link") {
            if (this.state.FormData.Title === null || this.state.FormData.Title === '') {

                errMsg.Title = "Link Required";
                returnVal = false;
                console.log('error link required');
            }
            else {
                const x: string = this.state.FormData.Title.toLowerCase();
                if (x.search("http") === 0) {
                    //ok
                }
                else {
                    errMsg.Title = "Link should start with http:// or https://";
                    returnVal = false;
                    console.log('Link should start with http:// or https://');
                }
            }
        }
        else {
            errMsg.Title = null;
        }

        this.setState({ ErrMessages: errMsg });

        return returnVal;
    }

    private loadEvidence = (): Promise<void> => {
        let x = this.app03EpicEvidencesService.read(this.props.evidenceId).then((e: IApp03EpicEvidence): void => {

            this.setState({
                FormData: e,
                FormDataBeforeChanges: e,
            });

        }, (err) => { if (this.props.errorHandling?.onError) this.props.errorHandling?.onError(`Error loading evidence data`, err.message); });
        return x;
    }

    public componentDidMount(): void {
        this.setState({ Loading: true });
        let loadingPromises = [this.loadLookups()];
        if (this.props.evidenceId) {
            this.setState({ EditRequest: true });
            loadingPromises.push(this.loadEvidence());
        }
        Promise.all(loadingPromises).then(p => this.onAfterLoad(p[1])).then(p => this.setState({ Loading: false })).catch(err => this.setState({ Loading: false }));
    }

    private loadLookups(): Promise<any> {
        let proms: any[] = [];
        return Promise.all(proms);
    }

    private onAfterLoad = (entity: types.IEntity): void => {

    }

    private changeTextField = (value: string, f: string): void => {
        this.setState({ FormData: this.cloneObject(this.state.FormData, f, value), FormIsDirty: true });
    }

    private cloneObject(obj, changeProp?, changeValue?) {
        if (changeProp)
            return { ...obj, [changeProp]: changeValue };
        return { ...obj };
    }
    protected changeChoiceGroup = (ev, option: IChoiceGroupOption, f: string): void => {
        const selectedKey = option.key;
        this.setState({ FormData: this.cloneObject(this.state.FormData, f, selectedKey)/*, FormIsDirty: true*/ });

    }
}